import client from '../httpClient';

const userGetShareApi = (userId, divisionId) => {
  return client.get(`/users/receive/share-customers/${userId}?divisionId=${divisionId}`);
};

export default userGetShareApi;
